<div class="container-fluid mt-4">
  <div class="card">
    <div class="card-header">
      <h3 class="mb-0">Quản lý TikTok Ads</h3>
    </div>

    <div class="card-body">
      <!-- FlashSale Status Summary Badges -->
      <div class="alert alert-summary mb-4" *ngIf="products.length > 0 || productsCountByStatus.allRunning > 0 || productsCountByStatus.partiallyRunning > 0 || productsCountByStatus.notRunning > 0">
        <div class="row g-3">
          <div class="col-md-3 col-sm-6">
            <div class="summary-badge">
              <span class="badge bg-success p-3"
                    [class.active-filter]="flashSaleStatusFilter === 'dang-chay'"
                    [style.cursor]="merchantId ? 'pointer' : 'default'"
                    [style.opacity]="flashSaleStatusFilter && flashSaleStatusFilter !== 'dang-chay' ? '0.5' : '1'"
                    (click)="merchantId && toggleStatusFilter('dang-chay')">
                <i class="fas fa-check-circle me-2"></i>
                <strong>Đang chạy:</strong> {{ productsCountByStatus.allRunning }}
              </span>
            </div>
          </div>
          <div class="col-md-3 col-sm-6">
            <div class="summary-badge">
              <span class="badge bg-warning text-dark p-3"
                    [class.active-filter]="flashSaleStatusFilter === 'chay-mot-phan'"
                    [style.cursor]="merchantId ? 'pointer' : 'default'"
                    [style.opacity]="flashSaleStatusFilter && flashSaleStatusFilter !== 'chay-mot-phan' ? '0.5' : '1'"
                    (click)="merchantId && toggleStatusFilter('chay-mot-phan')">
                <i class="fas fa-exclamation-circle me-2"></i>
                <strong>Chạy một phần:</strong> {{ productsCountByStatus.partiallyRunning }}
              </span>
            </div>
          </div>
          <div class="col-md-3 col-sm-6">
            <div class="summary-badge">
              <span class="badge bg-secondary p-3"
                    [class.active-filter]="flashSaleStatusFilter === 'khong-chay'"
                    [style.cursor]="merchantId ? 'pointer' : 'default'"
                    [style.opacity]="flashSaleStatusFilter && flashSaleStatusFilter !== 'khong-chay' ? '0.5' : '1'"
                    (click)="merchantId && toggleStatusFilter('khong-chay')">
                <i class="fas fa-circle me-2"></i>
                <strong>Không chạy:</strong> {{ productsCountByStatus.notRunning }}
              </span>
            </div>
          </div>
          <div class="col-md-3 col-sm-6">
            <div class="summary-badge">
              <span class="badge bg-info p-3">
                <i class="fas fa-list me-2"></i>
                <strong>Tổng:</strong> {{ totalProductsOfMerchant }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Filters -->
      <div class="row mb-4">
        <div class="col-md-3">
          <label class="form-label">Chọn merchant</label>
          <ng-select
            [(ngModel)]="merchantId"
            (change)="onMerchantChange()"
            [items]="merchants"
            bindLabel="name"
            bindValue="merchantId"
            placeholder="Chọn merchant..."
            [clearable]="true"
            [searchable]="true">
          </ng-select>
        </div>
        <div class="col-md-4">
          <label class="form-label">Tìm sản phẩm</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Tên sản phẩm, SKU..."
              [(ngModel)]="searchKeyword"
              (keyup.enter)="searchProducts()">
            <button class="btn btn-outline-secondary" (click)="searchProducts()">
              <i class="fas fa-search"></i> Tìm
            </button>
          </div>
        </div>
      </div>

      <!-- Loading State -->
      <div *ngIf="isLoading" class="alert alert-info">
        <span class="spinner-border spinner-border-sm me-2"></span>
        Đang tải sản phẩm...
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoading && merchantId && products.length === 0" class="alert alert-warning">
        Không tìm thấy sản phẩm cho merchant này.
      </div>

      <!-- Products Table -->
      <div *ngIf="!isLoading && products.length > 0" class="table-responsive">
        <table class="table table-hover table-striped">
          <thead class="table-light">
            <tr>
              <th style="width: 40px;"></th>
              <th>Tên sản phẩm</th>
              <th>Mã sản phẩm</th>
              <th class="text-center">Trạng thái FlashSale</th>
            </tr>
          </thead>
          <tbody>
            <!-- Product Row -->
            <ng-container *ngFor="let product of products">
              <tr class="product-row" (click)="toggleProductDetails(product)" style="cursor: pointer;">
                <td>
                  <i class="fas"
                     [ngClass]="expandedProductId === product.id ? 'fa-chevron-down' : 'fa-chevron-right'">
                  </i>
                </td>
                <td>
                  {{ product.title }}
                </td>
                <td>
                  <code>{{ product.tikTokProductId }}</code>
                </td>
                <td>
                  <span class="badge" [ngClass]="getBadgeClass(getStatusLabel(product))"
                        [title]="getExpirationTooltip(product)">
                    <i class="fas" [ngClass]="getStatusIcon(getStatusLabel(product))"></i>
                    <span [ngSwitch]="getStatusLabel(product)">
                      <span *ngSwitchCase="'dang-chay'">Đang chạy</span>
                      <span *ngSwitchCase="'chay-mot-phan'">Chạy một phần</span>
                      <span *ngSwitchDefault>Không chạy</span>
                    </span>
                    <br>
                    <small>({{ getSkuStatusText(product) }})</small>
                  </span>
                </td>
              </tr>

              <!-- Variations Detail Row (Nested Table) -->
              <tr *ngIf="expandedProductId === product.id" class="detail-row">
                <td colspan="7" class="p-0">
                  <div class="p-4 bg-light">
                    <!-- Product Info -->
                    <div class="row mb-3 pb-3 border-bottom">
                      <div class="col-md-3">
                        <small class="text-muted">Mã sản phẩm:</small><br>
                        <code>{{ product.tikTokProductId }}</code>
                      </div>
                      <div class="col-md-3">
                        <small class="text-muted">Không bán:</small><br>
                        {{ product.isNotForSale ? 'Có' : 'Không' }}
                      </div>
                      <div class="col-md-3">
                        <small class="text-muted">Khu vực bán:</small><br>
                        <small>{{ product.salesRegions || '-' }}</small>
                      </div>
                      <div class="col-md-3">
                        <small class="text-muted">Ngày tạo:</small><br>
                        <small>{{ product.createdTime | date:'short' }}</small>
                      </div>
                    </div>

                    <!-- Variations Loading State -->
                    <div *ngIf="product.loadingVariations" class="text-center py-3">
                      <span class="spinner-border spinner-border-sm me-2"></span>
                      Đang tải biến thể...
                    </div>

                    <!-- Variations Table -->
                    <h6 class="mb-3" *ngIf="!product.loadingVariations">Biến thể sản phẩm (SKU)</h6>
                    <div class="table-responsive" *ngIf="!product.loadingVariations">
                      <table class="table table-sm table-bordered mb-0">
                        <thead class="table-light">
                          <tr>
                            <th>Mã biến thể</th>
                            <th>SKU người bán</th>
                            <th class="text-center">Số lượng</th>
                            <th>Trạng thái FlashSale</th>
                            <th style="width: 150px;">Lỗi</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let variation of getSortedVariations(product)"
                              [class.table-danger]="variation.failureMessage">
                            <td><code class="small">{{ variation.variationId }}</code></td>
                            <td>{{ variation.sellerSku }}</td>
                            <td class="text-center">{{ variation.quantity }}</td>
                            <td>
                              <ng-container *ngIf="variation.isInFlashSale && variation.flashSaleStatus === 'Created' && !variation.isExpired">
                                <span class="badge bg-info">
                                  <i class="fas fa-check"></i> Đang chạy
                                </span>
                                <div class="flash-sale-progress mt-1">
                                  <div class="progress" style="height: 4px;">
                                    <div class="progress-bar bg-info"
                                         [style.width.%]="getFlashSaleProgress(variation.batchStartTime, variation.batchEndTime)">
                                    </div>
                                  </div>
                                  <small class="text-muted" style="font-size: 0.65rem; white-space: nowrap;">
                                    Kết thúc: {{ convertToVNTime(variation.batchEndTime) }}
                                  </small>
                                </div>
                              </ng-container>
                              <span *ngIf="variation.isExpired" class="badge bg-warning text-dark"
                                    [title]="'Hết hạn lúc: ' + convertToVNTime(variation.batchEndTime)">
                                <i class="fas fa-clock"></i> Hết hạn
                              </span>
                              <span *ngIf="variation.failureMessage" class="badge bg-danger">
                                <i class="fas fa-exclamation"></i> Lỗi
                              </span>
                              <span *ngIf="!variation.isInFlashSale && !variation.isExpired && !variation.failureMessage"
                                    class="badge bg-secondary">
                                <i class="fas fa-circle"></i> Không chạy
                              </span>
                            </td>
                            <td style="max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                              <small *ngIf="variation.failureMessage" class="text-danger fail-msg-text"
                                     (mouseenter)="onFailMsgEnter($event, variation.failureMessage)"
                                     (mousemove)="onFailMsgMove($event)"
                                     (mouseleave)="onFailMsgLeave()">
                                {{ variation.failureMessage }}
                              </small>
                              <span *ngIf="!variation.failureMessage" class="text-muted">-</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- No variations message -->
                    <div *ngIf="!product.loadingVariations && (!product.variations || product.variations.length === 0)" class="alert alert-info mb-0">
                      Không có biến thể cho sản phẩm này.
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <nav aria-label="Page navigation" *ngIf="!isLoading && products.length > 0" class="mt-4">
        <ul class="pagination justify-content-center">
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a class="page-link" (click)="previousPage()" href="javascript:void(0);">Trước</a>
          </li>
          <li class="page-item active">
            <span class="page-link">Trang {{ currentPage }} / {{ (totalProducts / pageSize) | number:'1.0-0' }}</span>
          </li>
          <li class="page-item" [class.disabled]="(currentPage * pageSize) >= totalProducts">
            <a class="page-link" (click)="nextPage()" href="javascript:void(0);">Tiếp</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>

<!-- Global fixed tooltip -->
<div *ngIf="showTooltip" class="custom-tooltip" [style.left.px]="tooltipX" [style.top.px]="tooltipY">
  {{ tooltipText }}
</div>
